export default Object.freeze({
  MY_POLLS: 'my',
  ALL_POLLS: 'all',
  PRE_POLLS: 'pre',
  OPEN_POLLS: 'open',
  CLOSE_POLLS: 'close',
  CANCEL_POLLS: 'cancel'
})
